import { z } from 'zod';

// The garage permission catalogue (docs/02) — stable keys consumed by backend
// middleware and frontend guards alike. Custom roles can only combine these.

export const PERMISSION_KEYS = [
  'garage.profile.view',
  'garage.profile.edit',
  'staff.view',
  'staff.invite',
  'staff.manage',
  'content.view',
  'benefits.view',
  'events.view',
  'events.garage.create',
  'events.garage.manage',
  'rewards.view',
  'rewards.redeem',
  'fleet.view',
  'fleet.manage',
] as const;

export type PermissionKey = (typeof PERMISSION_KEYS)[number];
export const permissionKeyEnum = z.enum(PERMISSION_KEYS);

// Seeded system roles (docs/02) — is_system = true, undeletable, renameable
// only via terminology overrides.
export const SYSTEM_ROLE_SLUGS = ['owner', 'manager', 'service_advisor', 'technician'] as const;
export type SystemRoleSlug = (typeof SYSTEM_ROLE_SLUGS)[number];

// Default role → permission matrix (docs/02)
export const DEFAULT_ROLE_PERMISSIONS: Record<SystemRoleSlug, PermissionKey[]> = {
  owner: [
    'garage.profile.view', 'garage.profile.edit', 'staff.view', 'staff.invite', 'staff.manage',
    'content.view', 'benefits.view', 'events.view', 'events.garage.create', 'events.garage.manage',
    'rewards.view', 'rewards.redeem', 'fleet.view', 'fleet.manage',
  ],
  manager: [
    'garage.profile.view', 'garage.profile.edit', 'staff.view', 'staff.invite', 'staff.manage',
    'content.view', 'benefits.view', 'events.view', 'events.garage.create', 'events.garage.manage',
    'rewards.view', 'rewards.redeem', 'fleet.view', 'fleet.manage',
  ],
  service_advisor: [
    'garage.profile.view', 'content.view', 'benefits.view', 'events.view', 'events.garage.create',
    'rewards.view', 'fleet.view',
  ],
  technician: [
    'garage.profile.view', 'content.view', 'benefits.view', 'events.view',
    'rewards.view',
  ],
};
